module.exports = __webpack_public_path__ + "img/1715650236090-WhatsApp Image 2024-05-14 at 09.14.44.jpeg.e2d1a8b4.webp";